<template>
  <section class="changelog-page">
    <b-card v-for="changelogEntry in items" :header="'Update: ' + changelogEntry.name + ' - ' + fullHumanDate(
                          changelogEntry.createDateTimeUtc,
                          'MMMM Do, YYYY'
                        )" :key="changelogEntry.id">
      <div class="vue-prosemirror changelogentry" style="color: #495057;" >
        <vue-markdown :key="changelogEntry.content" :initialValue="changelogEntry.content"></vue-markdown>
        </div>
    </b-card>
  </section>
</template>

<script>
import { Viewer } from '@toast-ui/vue-editor';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'ChangelogPublic',
  mixins: [crudMixinGen('docs/changelog'), myCommonDataMixin],
  components: {
    'vue-markdown': Viewer,
  },

  data: () => ({
  }),
  computed: {
  },

  mounted() {
    this.loadAllItems();
  },

  methods: {
    loadAllItems(hnl = () => {}) {
      this.$http
        .get('/api/docs/changelog')
        .then(resp => {
          this.items = resp.data;
          hnl();
        })
        .catch(err => {});
    },
    fullHumanDate(date, str) {
      return this.$moment
        .utc(date)
        .local()
        .format(str);
    },
  }
};
</script>
